import { useState } from 'react';

import { type SearchView } from '@/types/schema/views/SearchView';
import { isPageEditor } from '@/utils/iframe';
import { useViewContext } from '@/components/views/ViewContext';
import { ViewHeaderSection } from '@/components/views/ViewHeaderSection';
import { useViewQueryParamsContext } from '@/components/views/ViewQueryParamsContext';
import { ResultsDisplay } from './results-display/ResultsDisplay';
import { SearchFilters } from './search-options/SearchFilters';

export function SearchViewRender() {
  const { view } = useViewContext<SearchView>();
  const { searchViewParams: params } = useViewQueryParamsContext();

  const [shouldShowResults, setShouldShowResults] = useState(
    // On initial load, we want to show results if the `initial_results` setting is enabled, or if there are any filters already applied in the URL
    !!view.initial_results || !!(params.filters && params.filters.length > 0)
  );

  return (
    <div>
      <ViewHeaderSection view={view} className="mb-4" />
      <div className="flex flex-col gap-6">
        <SearchFilters
          // When rendering the search filters in the page editor, the filter rules don't have a stable order, since the inputs can be reordered and modified from the page editor itself.
          // To ensure a stable order after every change, we need to remount the component whenever `view.groups` changes
          key={isPageEditor() ? JSON.stringify(view.groups) : undefined}
          setShouldShowResults={setShouldShowResults}
        />
        <ResultsDisplay shouldShowResults={shouldShowResults} />
      </div>
    </div>
  );
}
